import { useState } from 'react';

import {
  FieldBlueprint,
  FieldTypes,
  InformationFieldBlueprint,
  InformationFieldBlueprintVariants,
} from '@zinnia/form-engine-sdk';

import {
  FieldDataFromBlueprint,
  FieldDataHookReturnValue,
  useCastBlueprintToFieldType,
} from '../../Helpers/helperTypes';

export type InformationFieldData = FieldDataFromBlueprint<InformationFieldBlueprint, 'variant'>;

export type InformationFieldSetters = {
  setVariant: React.Dispatch<React.SetStateAction<InformationFieldData['variant']>>;
};

export function useInformationFieldData({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<InformationFieldData, InformationFieldSetters> {
  const initialDataAsInformationField = useCastBlueprintToFieldType<InformationFieldBlueprint>(
    FieldTypes.information,
    initialData,
  );

  const [variant, setVariant] = useState<InformationFieldData['variant']>(
    initialDataAsInformationField?.variant || InformationFieldBlueprintVariants.paragraph,
  );

  return {
    data: {
      variant,
    },
    setters: {
      setVariant,
    },
    clearData: () => {
      setVariant(initialDataAsInformationField?.variant || InformationFieldBlueprintVariants.paragraph);
    },
  };
}
